<ng-container *ngIf="prescriptionItem === null; else prescriptionDetaills">
  <div class="no-appoint-message">
    <div>No Data Found!</div>
  </div>
</ng-container>

<ng-template #prescriptionDetaills>
  <app-prescription-sheet
    #rxSheet
    [prescription]="prescriptionItem"
    [showPrintButton]="true"
  >
  </app-prescription-sheet>
</ng-template>
